<template>
  <div class="m-astro-chart">
    <strong class="m-astro-chart__label">{{ label }}</strong>
    <span
      class="m-astro-chart__position"
      :class="`house-${position}`"
      v-for="position in 12"
      :key="position"
    >
      <span
        v-if="chart.lagna == `h${position}`"
        class="m-astro-chart__planet"
        title="லக்கினம்"
        >(ல)</span
      >
      <span
        v-if="chart.mandhi == `h${position}`"
        class="m-astro-chart__planet"
        title="மாந்தி"
        >(மா)</span
      >
      <span
        class="m-astro-chart__planet"
        v-for="(planet, idx) in chart[`h${position}`]"
        :key="idx"
        :title="planet"
        >{{ planet }}</span
      >
    </span>
  </div>
</template>

<script>
export default {
  name: "AstroChart",
  props: {
    chart: Object,
    label: String,
  },
};
</script>

<style lang="scss">
@import "@/scss/m-astro-chart";
</style>
